import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { TRANSLATIONS } from "@/lib/translations";

const LangCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

function detectInitial() {
  try {
    const stored = localStorage.getItem("cms.lang");
    if (stored === "en" || stored === "hi") return stored;
  } catch (_e) {
    /* ignore */
  }
  return "en";
}

export function LanguageProvider({ children, initialLang }) {
  const [lang, setLangState] = useState(initialLang || detectInitial());

  useEffect(() => {
    if (initialLang && initialLang !== lang) setLangState(initialLang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialLang]);

  useEffect(() => {
    try {
      localStorage.setItem("cms.lang", lang);
    } catch (_e) {
      /* ignore */
    }
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = useCallback(
    (key, fallback) => {
      const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
      return dict[key] || fallback || key;
    },
    [lang]
  );

  return (
    <LangCtx.Provider value={{ lang, t, setLang: setLangState }}>
      {children}
    </LangCtx.Provider>
  );
}

export function useLang() {
  return useContext(LangCtx);
}
